import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLSpanElement>,
        HTMLSpanElement
        > {
}

const AppNotificationText: React.FC<IProps> = (props) => {

    const {ref, ...DivProps} = props;

    return <NotificationText {...DivProps} />

};

export default AppNotificationText;

const NotificationText = styled.span`
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    flex:1;
    text-align: center;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/app_notification_text.tsx